import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import Helmet from 'react-helmet';
import { Tabs } from 'antd';
import Layout from '../components/Layout';
import SEO from '../components/SEO';
import RelatedLinks from '../components/RelatedLinks';

const contentStyle = {
  height: '72px',
  lineHeight: '72px',
  flex: 1,
  margin: '0 4px',
  opacity: '1',
  borderRadius: '36px',
  fontFamily: 'PingFangSC-Medium, PingFang SC'
};

const tabBar = (props, defaultTabBar) => (
  <div className="about-content-tab-item">
    <defaultTabBar {...props} defaultActiveKey="0" />
  </div>
);

const About = () => {
  const { TabPane } = Tabs;
  const data = useStaticQuery(graphql`
    query AboutQuery {
      aboutJson {
        title
        subTitle
        bannerImg
        itemSlogan {
          key
          value
        }
        content {
          key
          id
        }
        aboutValue {
          title
          content
        }
        partners {
          name
          url
        }
        advantage {
          img
          title
          subtitle
        }
        values
      }
    }
  `);
  const { title, subTitle, bannerImg, itemSlogan, aboutValue, partners, advantage, values } = data.aboutJson;
  const valueAlts = [
    '团队合作 — 魔鬼鱼企业核心价值观',
    '客户第一 — 魔鬼鱼企业核心价值观',
    '责任担当 — 魔鬼鱼企业核心价值观',
    '诚信正直 — 魔鬼鱼企业核心价值观',
    '拥抱变化 — 魔鬼鱼企业核心价值观'
  ];
  const pageTitle = '关于我们 - 魔鬼鱼订货平台';
  const pageDescription = '了解魔鬼鱼团队、企业文化、核心价值观与战略合作伙伴，我们致力于为宠物行业提供专业服务。';
  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '魔鬼鱼订货平台',
    url: 'https://www.mantas.cn',
    logo: 'https://www.mantas.cn/images/logo.png',
    description: '宠物行业一站式B2B订货平台，为宠物店、宠物医院、猫咖、繁育舍提供靠谱宠物进货渠道',
    foundingDate: '2020',
    foundingLocation: '上海',
    areaServed: 'CN',
    knowsAbout: ['宠物用品批发', '宠物店进货', '宠物B2B平台', '宠物用品订货'],
    sameAs: [],
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'service@10000pets.com',
      availableLanguage: ['Chinese']
    }
  };

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '关于我们',
    description: '了解魔鬼鱼团队、企业文化、核心价值观与战略合作伙伴',
    specialty: 'AboutPage'
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '魔鬼鱼订货平台是什么？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '魔鬼鱼订货平台是宠物行业一站式B2B订货平台，为宠物门店提供单件散拿、跨品牌混批的进货服务，解决门店库存积压问题。'
        }
      },
      {
        '@type': 'Question',
        name: '魔鬼鱼公司什么时候成立的？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '魔鬼鱼（上海）网络科技有限公司成立于2020年，总部位于上海浦东新区。'
        }
      },
      {
        '@type': 'Question',
        name: '魔鬼鱼平台服务覆盖哪些城市？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '魔鬼鱼平台服务覆盖全国，为全国各地宠物门店提供订货服务。'
        }
      }
    ]
  };
  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首页',
        item: 'https://www.mantas.cn'
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: '关于我们',
        item: 'https://www.mantas.cn/about'
      }
    ]
  };
  return (
    <Layout body-class="page-about">
      <SEO title={pageTitle} description={pageDescription} path="/about" />
      <Helmet>
        <meta
          name="keywords"
          content="魔鬼鱼公司, 魔鬼鱼介绍, 魔鬼鱼订货平台, 宠物行业, 企业介绍, 上海宠物公司, 宠物B2B企业, 魔鬼鱼网络科技, 宠物平台公司, 关于我们"
        />
        <script type="application/ld+json">
          {JSON.stringify(organizationSchema)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(webPageSchema)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>
        <script type="application/ld+json" key="breadcrumb">
          {JSON.stringify(breadcrumbSchema)}
        </script>
      </Helmet>
      <div className="about_body">
        <div className="about_header">
          {/* <img src={bannerImg} alt="banner" className="about_banner" /> */}
          <picture>
            <source
              srcSet={`/images/2x/about/${bannerImg}@2x.png`}
              media="(min-resolution: 2dppx)"
            />
            <source
              srcSet={`/images/3x/about/${bannerImg}@3x.png`}
              media="(min-resolution: 3dppx)"
            />
            <img
              className="about_banner"
              src={`/images/1x/about/${bannerImg}@1x.png`}
              title="关于我们"
              alt="魔鬼鱼订货平台 宠物行业B2B供应链平台关于我们"
            />
          </picture>
          <div className="about_header_content">
            <h1 className="about_h1_title">
              魔鬼鱼订货平台 — 宠物行业 B2B 供应链平台
            </h1>
            <div className="about_title">
              <source
                srcSet={`/images/2x/about/${title}@2x.png`}
                media="(min-resolution: 2dppx)"
              />
              <source
                srcSet={`/images/3x/about/${title}@3x.png`}
                media="(min-resolution: 3dppx)"
              />
              <img
                className="about_title_img"
                src={`/images/1x/about/${title}@1x.png`}
                title="魔鬼鱼订货平台"
                alt="魔鬼鱼订货平台"
              />
            </div>
            <div className="about_sub_title">{subTitle}</div>
            <div className="about_sub_title_divider" />
            {itemSlogan && itemSlogan.map((item, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <React.Fragment key={index}>
                <div className="about_item_title">{item.key}</div>
                {item.value && item.value.map(value => (
                  <div className="about_item_content">{value}</div>
                ))}
              </React.Fragment>
            ))}
          </div>
        </div>
        <div className="about-content">
          <div className="card-container">
            <Tabs
              type="card"
              className="card-bar"
              centered="true"
              tabPosition="top"
              animated={false}
              keyboard="true"
              defaultActiveKey="'3'"
              tabBarStyle={contentStyle}
            >
              <TabPane tab="关于魔鬼鱼" key="1">
                {aboutValue && aboutValue.map((item, index) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <React.Fragment key={index}>
                    <h2 className="about-content-tab-item-content-title">
                      {item.title}
                    </h2>
                    {item.content.split('\n\n').filter(Boolean).map((paragraph, pIdx) => (
                      <div key={pIdx} className="about-content-tab-item-content-subtitle">
                        {paragraph}
                      </div>
                    ))}
                  </React.Fragment>
                ))}
              <div className="certifications-section">
                <img
                  src="/images/about/certifications.png"
                  alt="魔鬼鱼平台经营资质证书展示"
                  className="certifications-image"
                />
              </div>
              </TabPane>
              <TabPane tab="战略合作伙伴" key="2">
                <h2 className="about-content-tab-item-partner-title">
                  战略合作伙伴
                </h2>
                <div className="about-content-tab-item-partner-brand-container">
                  {partners && partners.map(item => (
                    <div className="about-content-tab-item-partner-brand">
                      <picture>
                        <source
                          srcSet={`/images/2x/about/${item.url}@2x.png`}
                          media="(min-resolution: 2dppx)"
                        />
                        <source
                          srcSet={`/images/3x/about/${item.url}@3x.png`}
                          media="(min-resolution: 3dppx)"
                        />
                        <img
                          className="about-content-tab-item-partner-brand-img"
                          src={`/images/1x/about/${item.url}@1x.png`}
                          title={item.name}
                          alt={item.name}
                        />
                      </picture>
                      {/* <img className="" src={item.url} alt={item.name} /> */}
                    </div>
                  ))}
                </div>
              </TabPane>
              <TabPane tab="特色优势" key="3">
                <h2 className="about-content-tab-item-adv-title-title">
                  特色优势
                </h2>
                <div className="about-content-tab-item-adv">
                  {/* {advantage && advantage.map(item => (
                    <div className="about-content-tab-item-adv-item">
                      <div className="about-content-tab-item-adv-item-img-container">
                        <picture>
                          <source
                            srcSet={`/images/2x/about/${item.img}@2x.png`}
                            media="(min-resolution: 2dppx)"
                          />
                          <source
                            srcSet={`/images/3x/about/${item.img}@3x.png`}
                            media="(min-resolution: 3dppx)"
                          />
                          <img
                            className="about-content-tab-item-adv-item-img"
                            src={`/images/1x/about/${item.img}@1x.png`}
                            title={item.title}
                            alt={item.title}
                          />
                        </picture>
                      </div>
                      <div className="about-content-tab-item-adv-item-content">
                        <div className="about-content-tab-item-adv-title">
                          {item.title}
                        </div>
                        <div className="about-content-tab-item-adv-subtitle">
                          {item.subtitle}
                        </div>
                      </div>
                    </div>
                  ))} */}
                  <div className="about-content-tab-item-adv-item about-content-tab-item-adv-item-1">
                    <div className="about-content-tab-item-adv-item-img-container about-content-tab-item-adv-item-img-container-1">
                      <picture>
                        <source
                          srcSet={`/images/2x/about/${advantage[0].img}@2x.png`}
                          media="(min-resolution: 2dppx)"
                        />
                        <source
                          srcSet={`/images/3x/about/${advantage[0].img}@3x.png`}
                          media="(min-resolution: 3dppx)"
                        />
                        <img
                          className="about-content-tab-item-adv-item-img about-content-tab-item-adv-item-img-1"
                          src={`/images/1x/about/${advantage[0].img}@1x.png`}
                          title={advantage[0].title}
                          alt={advantage[0].title}
                        />
                      </picture>
                    </div>
                    <div className="about-content-tab-item-adv-item-content about-content-tab-item-adv-item-content-1">
                      <h3 className="about-content-tab-item-adv-title about-content-tab-item-adv-title-1">
                        {advantage[0].title}
                      </h3>
                      <div className="about-content-tab-item-adv-subtitle about-content-tab-item-adv-subtitle-1">
                        {advantage[0].subtitle}
                      </div>
                    </div>
                  </div>
                  <div className="about-content-tab-item-adv-item about-content-tab-item-adv-item-2">
                    <div className="about-content-tab-item-adv-item-img-container about-content-tab-item-adv-item-img-container-2">
                      <picture>
                        <source
                          srcSet={`/images/2x/about/${advantage[1].img}@2x.png`}
                          media="(min-resolution: 2dppx)"
                        />
                        <source
                          srcSet={`/images/3x/about/${advantage[1].img}@3x.png`}
                          media="(min-resolution: 3dppx)"
                        />
                        <img
                          className="about-content-tab-item-adv-item-img about-content-tab-item-adv-item-img-2"
                          src={`/images/1x/about/${advantage[1].img}@1x.png`}
                          title={advantage[1].title}
                          alt={advantage[1].title}
                        />
                      </picture>
                    </div>
                    <div className="about-content-tab-item-adv-item-content about-content-tab-item-adv-item-content-2">
                      <h3 className="about-content-tab-item-adv-title about-content-tab-item-adv-title-2">
                        {advantage[1].title}
                      </h3>
                      <div className="about-content-tab-item-adv-subtitle about-content-tab-item-adv-subtitle-2">
                        {advantage[1].subtitle}
                      </div>
                    </div>
                  </div>
                  <div className="about-content-tab-item-adv-item about-content-tab-item-adv-item-3">
                    <div className="about-content-tab-item-adv-item-img-container about-content-tab-item-adv-item-img-container-3">
                      <picture>
                        <source
                          srcSet={`/images/2x/about/${advantage[2].img}@2x.png`}
                          media="(min-resolution: 2dppx)"
                        />
                        <source
                          srcSet={`/images/3x/about/${advantage[2].img}@3x.png`}
                          media="(min-resolution: 3dppx)"
                        />
                        <img
                          className="about-content-tab-item-adv-item-img about-content-tab-item-adv-item-img-3"
                          src={`/images/1x/about/${advantage[2].img}@1x.png`}
                          title={advantage[2].title}
                          alt={advantage[2].title}
                        />
                      </picture>
                    </div>
                    <div className="about-content-tab-item-adv-item-content about-content-tab-item-adv-item-content-3">
                      <h3 className="about-content-tab-item-adv-title about-content-tab-item-adv-title-3">
                        {advantage[2].title}
                      </h3>
                      <div className="about-content-tab-item-adv-subtitle about-content-tab-item-adv-subtitle-3">
                        {advantage[2].subtitle}
                      </div>
                    </div>
                  </div>
                </div>
              </TabPane>
              <TabPane tab="企业价值观" key="4">
                <h2 className="about-content-tab-item-value-title">
                  企业价值观
                </h2>
                <div className="about-content-tab-item-value-subtitle">
                  团队合作/客户第一/责任担当/诚信正直/拥抱变化
                </div>
                <div className="about-content-tab-item-value">
                  {values && values.map((item, index) => (
                    <div className="about-content-tab-item-value-img-container" key={index}>
                      {/* <img className="about-content-tab-item-value-img" src={item} alt="value" /> */}
                      <picture>
                        <source
                          srcSet={`/images/2x/about/${item}@2x.png`}
                          media="(min-resolution: 2dppx)"
                        />
                        <source
                          srcSet={`/images/3x/about/${item}@3x.png`}
                          media="(min-resolution: 3dppx)"
                        />
                        <img
                          className="about-content-tab-item-value-img"
                          src={`/images/1x/about/${item}@1x.png`}
                          title={valueAlts[index] || '魔鬼鱼企业价值观'}
                          alt={valueAlts[index] || '魔鬼鱼企业价值观'}
                        />
                      </picture>
                    </div>
                  ))}
                </div>
              </TabPane>
            </Tabs>
          </div>
        </div>
        <section className="about-related-links">
          <a href="/help">帮助中心</a>
          <a href="/supplier">供应商入驻</a>
        </section>
        {/* 站内互链（GEO 延伸阅读） */}
        <RelatedLinks
          title="延伸阅读"
          links={[
            { label: '供应商入驻', to: '/supplier' },
            { label: '注册指南', to: '/registration-guide/' },
          ]}
        />
      </div>
    </Layout>
  );
};
export default About;
